import React from 'react';

/**
 * One tile in the platform-stats photo strip on the refreshed
 * FarmerHome. Circular thumbnail + big count + role label. The strip
 * itself lives on the home page; this is just one entry so the layout
 * scales when we add / remove roles.
 *
 * `image` is a URL served from /public (e.g. /assets/farmer-home/
 * stakeholder-farmer.jpg).
 */
export default function StakeholderStat({ image, count, label, alt, className = '', onClick, dataTestId }) {
  const body = (
    <>
      <img
        src={image}
        alt={alt || ''}
        className="w-16 h-16 rounded-full object-cover flex-shrink-0 shadow-sm ring-2 ring-white"
        loading="lazy"
      />
      <p className="font-heading text-lg font-bold text-farm-forest mt-2 leading-none">{count}</p>
      <p className="text-[11px] text-farm-forest/70 mt-0.5 leading-tight">{label}</p>
    </>
  );
  // Tappable when the strip links to the people directory.
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`flex flex-col items-center text-center rounded-xl py-1 hover:bg-white/60 focus:outline-none focus:ring-2 focus:ring-farm-primary ${className}`}
        data-testid={dataTestId}
      >
        {body}
      </button>
    );
  }
  return (
    <div className={`flex flex-col items-center text-center ${className}`} data-testid={dataTestId}>
      {body}
    </div>
  );
}
